/* 
* jQuery random items Plugin
*/
;(function($){

  function RandomItems(options){
    this.options = $.extend({
      activeClass: 'active',
      items: 'img',
      switchTime: 3000,
      itemRows:2,
      itemCols: 6
    }, options);
    this.init();
  }
  RandomItems.prototype = {
    init: function(){
      if(this.options.holder){
        this.findElements();
        this.buildStructure();
        this.startAutorotate();
        this.makeCallback('onInit', this);
      }
    },
    findElements: function(){
      this.$holder = jQuery(this.options.holder);
      this.$items = this.$holder.find(this.options.items).remove();
      this.dataArray = [];
      this.arrayItems = [];
      this.imageNum = 0;
      this.ind = 0;
     
    },
    sortElements: function(items) {
      function compareRandom(a,b) {
        return Math.random() - 0.5;
      }
      items.sort(compareRandom);
    },
    groupItem: function() {
      var self = this;
       this.arrayItems.forEach(function(obj, i) {
         obj.item.addClass('group-' + self.dataArray[i]);
      });
    },
    createList: function() {
      var rows = Math.floor(this.$items.length / this.options.itemCols);
      var rest = this.options.itemCols % this.options.itemRows;
      var width, widthAlt;

      this.$list = jQuery('<ul></ul>').appendTo(this.$holder);
      if(rest){
       width = 100 / (Math.floor(this.options.itemCols / this.options.itemRows));
       widthAlt = 100 / (Math.floor(this.options.itemCols / this.options.itemRows) + rest);
      } else{
        width = 100 / this.options.itemCols * this.options.itemRows;
        widthAlt = width;
      }
      for (var i = 0; i < this.options.itemCols; i++) {
        var obj = {
          item: jQuery('<li></li>'),
          images: [],
          activeNum: 0
        }
        var otherImages, widthItem;

        this.arrayItems.push(obj);
        this.dataArray.push(i);

        if(i >= Math.floor(this.options.itemCols / this.options.itemRows)) {
          widthItem = widthAlt + '%';

        } else {
          widthItem = width + '%';
        }
        obj.item.appendTo(this.$list).css({
          width: widthItem
        });

        for (var j = 0; j < rows; j++) {
          var img = this.$items.eq(this.options.itemCols * j + i);
          obj.images.push(img.appendTo(obj.item));
        }
        otherImages = this.$items.eq(this.options.itemCols * rows + i);
        if(otherImages.length){
          obj.images.push(otherImages.appendTo(obj.item));
        }

        obj.images[obj.activeNum].addClass(this.options.activeClass);
      }
    },
    buildStructure: function() {
      this.sortElements(this.$items);
      this.createList();
      this.sortElements(this.dataArray);
      this.groupItem();
    },
    ruleSwitch: function(index) {
      var currentItem = this.arrayItems[index];
      currentItem.images[currentItem.activeNum].removeClass(this.options.activeClass);
      currentItem.activeNum++;
      if(currentItem.images.length === currentItem.activeNum){
        currentItem.activeNum = 0;
      }
      currentItem.images[currentItem.activeNum].addClass(this.options.activeClass);
      this.autoRotate();
    },
    autoRotate: function() {
      var self = this;
      clearTimeout(this.timer);
        if(!this.flagStop){
          this.timer = setTimeout(function() {
          self.switchItems();
        }, self.options.switchTime);
      }
    },
    switchItems: function() {
      var index;
      this.ind++;
      if(this.ind >= this.options.itemCols) {
        this.ind = 0;
      }
      index = this.dataArray[this.ind];
      this.ruleSwitch(index);
    },
    makeCallback: function(name) {
      if (typeof this.options[name] === 'function') {
        var args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    },
    stopAutorotate: function() {
      this.flagStop = true;
      clearTimeout(self.timer);
    },
    startAutorotate: function() {
      this.flagStop = false;
      this.autoRotate();
    },
    destroy: function() {
      var self = this;
      clearTimeout(self.timer);
      this.arrayItems.forEach(function(obj) {
        obj.images[obj.activeNum].removeClass(self.options.activeClass);
      });
      this.$items.appendTo(this.$holder);
      this.$list.remove();
      this.$holder.removeData('RandomItems');
    }
  };
  $.fn.randomItems = function(opt){
    return this.each(function(){
      $(this).data('RandomItems', new RandomItems($.extend(opt,{holder:this})));
    });
  };
}(jQuery));